<template>
  <v-list-tile>
    <v-list-tile-action>
      <v-icon>view_day</v-icon>
    </v-list-tile-action>

    <v-list-tile-content>
      <v-list-tile-title class="font-weight-medium">
        Emissão de Boleto
        <v-icon small>help_outline</v-icon>
      </v-list-tile-title>
      <v-list-tile-sub-title v-if="partner === 'establishment'">Gere boletos bancários para que pagadores depositem direto em sua conta digital {{ account.fantasy_name }}</v-list-tile-sub-title>
      <v-list-tile-sub-title v-else >Gere boletos bancários para que pagadores depositem direto em sua conta digital {{ partnerName }}</v-list-tile-sub-title>
    </v-list-tile-content>
    <div class="text-center">
      <v-btn outline color="indigo" @click="newInvoiceBillForm">&nbsp;Gerar Boleto de Cobrança&nbsp;</v-btn>
      <new-payer-form :payersList="payersList" :isLoading="isLoading"></new-payer-form>
    </div>
    <new-slip-form />
  </v-list-tile>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { EventBus } from "@/services/event-bus";

export default {
  name: "NewInvoiceBill",
  created() {
    this.$store.dispatch('account/getAccount');
  },
  computed: {
    ...mapGetters({
      account: 'account/account',
      partner: 'account/partner',
      partnerName: 'account/partnerName',
      payersList: 'account/accountPayers',
      isLoading: 'account/isLoad',
      color: 'color',
    })
  },
  components: {
    newSlipForm: () => import('@/components/desktop/bills/actions/NewSlipForm.vue'),
    newPayerForm: () => import('@/components/desktop/bills/actions/NewPayerForm.vue'),
  },
  methods: {
    newInvoiceBillForm() {
      EventBus.$emit('show-new-slip-form');
    },
  }
};
</script>
